import { store } from '@/app/store';
import { useSelector } from 'react-redux';

// ─── Plain selectors (state accessors) ────────────────────────────────────────

export const selectRepliedMessageById = (state, msgId) => state.repliedMessagesData?.data?.[msgId];

export const selectAllRepliedMessages = state => state.repliedMessagesData?.data || {};

// ─── Store-direct helpers (non-React, use sparingly) ──────────────────────────

export const getRepliedMessageById = msgId => selectRepliedMessageById(store.getState(), msgId);

export const getAllRepliedMessages = () => selectAllRepliedMessages(store.getState());

// ─── React hooks ─────────────────────────────────────────────────────────────

export const useRepliedMessageById = msgId => useSelector(state => selectRepliedMessageById(state, msgId));
